"use client";

import { useTranslations } from "@/app/(site)/europe/useTranslations";
import * as C from "@/components";
import * as P from "@/parts";
import { ProductFull } from "@api";

export const EUStockedProductsSection = ({
  products,
}: {
  products: ProductFull[];
}) => {
  const { exploreOutLineupStockedInTheEu } = useTranslations();

  return (
    <C.PageSection className="my-20">
      <h2 className="text-center max-w-[700px] mx-auto mb-10">
        {exploreOutLineupStockedInTheEu}
      </h2>
      <P.EUStockedProducts products={products} />
    </C.PageSection>
  );
};
